<div class="text-center">
  <fgbcl-loading></fgbcl-loading>
</div>
